import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './VipLimitPage.module.css';

const ACTION_TITLES = {
  chapters_read: '阅读额度',
  words_favorited: '单词收藏',
  sentences_favorited: '句子收藏',
  notes_created: '笔记添加',
  vip_required: 'VIP 专属功能',
};

const VipLimitPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const action = state.action || 'chapters_read';
  const message = state.message || '';
  const limit = state.limit;
  const used = state.used;

  const actionTitle = ACTION_TITLES[action] || '功能使用';

  const isVipRequired = action === 'vip_required';
  const heading = isVipRequired
    ? 'VIP 专属功能'
    : `今日${actionTitle}额度已达上限`;
  const description =
    message ||
    (isVipRequired
      ? '此功能为 VIP 会员专属。升级 VIP，解锁全部高级功能，享受沉浸式学习体验。'
      : `您的每日免费${actionTitle}次数已用完。升级为 VIP 会员，解锁无限使用权限，享受沉浸式学习体验。`);

  return (
    <div className={styles.page}>
      <button type="button" className={styles.topBackBtn} onClick={() => navigate(-1)} aria-label="返回">
        <span className={`material-symbols-outlined ${styles.topBackIcon}`}>arrow_back</span>
      </button>
      <div className={styles.container}>
        {/* 用量标签 */}
        {limit != null && used != null && (
          <div className={styles.usageBadge}>
            今日已用 {used}/{limit}
          </div>
        )}

        {/* 标题 */}
        <h1 className={styles.heading}>{heading}</h1>

        {/* 描述 */}
        <p className={styles.description}>{description}</p>

        {/* VIP 特权 */}
        <div className={styles.benefits}>
          <div className={styles.benefitItem}>
            <span className={`material-icons-round ${styles.benefitIcon}`}>check_circle</span>
            <span>无限阅读全库小说</span>
          </div>
          <div className={styles.benefitItem}>
            <span className={`material-icons-round ${styles.benefitIcon}`}>check_circle</span>
            <span>无限收藏单词与句子</span>
          </div>
          <div className={styles.benefitItem}>
            <span className={`material-icons-round ${styles.benefitIcon}`}>check_circle</span>
            <span>无限添加学习笔记</span>
          </div>
          <div className={styles.benefitItem}>
            <span className={`material-icons-round ${styles.benefitIcon}`}>check_circle</span>
            <span>章节 PDF 导出下载</span>
          </div>
        </div>

        {/* 操作按钮 */}
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.backBtn}
            onClick={() => navigate(-1)}
          >
            返回上一页
          </button>
          <button
            type="button"
            className={styles.upgradeBtn}
            onClick={() => navigate('/vip/renewal')}
          >
            <span className="material-icons-round" style={{ fontSize: 20 }}>stars</span>
            升级 VIP 尊享特权
          </button>
        </div>

        {/* 底部提示 */}
        <p className={styles.footer}>
          遇到问题？{' '}
          <button
            type="button"
            className={styles.footerLink}
            onClick={() => navigate('/feedback')}
          >
            联系技术支持
          </button>
        </p>
      </div>
    </div>
  );
};

export default VipLimitPage;

